import './App.scss'
import { Amplify } from 'aws-amplify'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { AuthProvider } from '@/features/auth/providers'
import { config } from '@/libs/auth/amplify'
import { AppProvider } from '@/providers'

import { AppRouter } from './AppRouter'
import { FullScreenSpinner } from './components/elements'
import { DefaultErrorPage } from './routes/_protected/-components'

Amplify.configure(config)

function App(): JSX.Element {
  return (
    <AppProvider>
      <ErrorBoundary FallbackComponent={DefaultErrorPage}>
        <Suspense fallback={<FullScreenSpinner />}>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </Suspense>
      </ErrorBoundary>
    </AppProvider>
  )
}

export default App
